
import { defineComponent, ref } from 'vue';
import GlobalService from '@/core/services/GlobalService';
import eventService from "@/core/services/EventService";
import { errManager, showNotification } from '@/core/config/Tools';
import { status } from '@/core/data/shared';

export default defineComponent({
    props: {
        evento: {
            type: Object,
            required: true,
            default: {}
        },
        sport: {
            type: Object,
            required: true,
            default: {}
        },
        listStatus: {
            type: null,
            required: true,
            default: []
        },
        closure: {
            type: null,
            required: true,
            default: []
        },
        idinstitution: {
            type: null,
            required: true,
            default: null
        }
    },
    setup(props, {emit}) {
        const loading = ref(false);
        const titleDialog = ref('Modalidades');
        const isModalVisible = ref(false);
        const listModalidades = ref<any[]>([]);
        const isModalSelection = ref(false);
        const listNominal = ref<any[]>([]);
        const listChecks = ref<any>([])
        const getTest = ref<any>({});
        const loadingSelection = ref(false);
        const atleta1 = ref<any>(null);
        const atleta2 = ref<any>(null);

        const openModal = () => {
            isModalVisible.value = true
        };

        const getModalidades = async() => {
            loading.value = true;
            await GlobalService.get(`api/events/${props.evento.idevent}`, `test/14/institution?idinstitution=${props.idinstitution}`)
            .then((res)=>{
                listModalidades.value = res.data;
                loading.value = false;
            }).catch(({response})=>{
                loading.value = false;
                errManager(response)
            })
        }

        const getAtletas = async() => {
            if (listChecks.value.length == 0) {
                listChecks.value.length = 0
                props.listStatus.forEach((element: any) => {
                    listChecks.value.push(element.id)
                });
            }
             listNominal.value.length = 0
            await eventService.getNominal({
                idevent: props.evento.idevent,
                idsport: props.sport.idsport,
                checkdoc: listChecks.value,
                type_register: 'D',
            })
                .then((res) => {
                    listNominal.value = res.data
                }).catch(({ response }) => {
                    errManager(response)
                })
        }

        const onOpen = () => {
            getModalidades();
            getAtletas();
        }

        const addPrueba = (data: any) => {
            console.table(data)
            getTest.value = data;
            isModalSelection.value = true;
        }

        const guardarSeleccion = async(data:any) => {
            loadingSelection.value = true;
            await GlobalService.post('acreditation/guardar-prueba',
                {
                    idacreditation: data.idacreditation,
                    idevent: props.evento.idevent,
                    idsport: props.sport.idsport,
                    idcmp: 'CMP0010',
                    idtest: getTest.value?.code,
                    idniv: 'I',
                    idcat: data.gender
                }
            ).then((res)=>{
                loadingSelection.value = false;
                showNotification(res.data);
                if(res.data.status == 'success'){
                    getModalidades();
                }
            })
            .catch(({response})=>{
                loadingSelection.value = false;
                errManager(response)
            })
        }

        const deleteTest = async(idtest) => {
            loading.value = true;
            await GlobalService.post('acreditation/test-delete', {idtest: idtest})
            .then((res)=>{
                loading.value = false;
                showNotification(res.data);
                if(res.data.status == 'success'){
                    getModalidades();
                }
            })
            .catch(({response})=>{
                loading.value = false;
                errManager(response)
            })
        }

        const  guardarDoble = async() =>{
            if(atleta1.value !=null && atleta2.value !=null){
                loadingSelection.value = true;
                const sexo = getTest.value?.code == 'PB0164' ? 'igual' : '';
                await GlobalService.post('acreditation/testdoble',
                    {
                        idevent: props.evento.idevent,
                        idsport: props.sport.idsport,
                        idcmp: 'CMP0010',
                        idtest: getTest.value?.code,
                        idniv: 'I',
                        sexo: sexo,
                        atleta1: {
                            idacreditation: atleta1.value?.idacreditation,
                            idcat: atleta1.value?.gender
                        },
                        atleta2: {
                            idacreditation: atleta2.value?.idacreditation,
                            idcat: atleta2.value?.gender
                        },

                    }
                ).then((res)=>{
                    loadingSelection.value = false;
                    showNotification(res.data);
                    if(res.data.status == 'success'){
                        getModalidades();
                    }
                })
                .catch(({response})=>{
                    loadingSelection.value = false;
                    errManager(response)
                })
            } else {
                showNotification({status: 'error', title: 'SISDEU', message: 'Falta seleccionar atletas'});
            }
            
        }

        const deleteDouble = async(data: any, sexo:any, data2: any) => {
            console.table(data);
            loading.value = true;
            await GlobalService.post('acreditation/delete-test-doble', {
                idevent: props.evento.idevent,
                idsport: props.sport.idsport,
                idcmp: 'CMP0010',
                idtest: data,
                idniv: 'I',
                idcat: sexo,
                couple: data2.couple,
                lista: data2.lista
            }).then((res)=>{
                loading.value = false;
                showNotification(res.data);
                if(res.data.status == 'success'){
                    getModalidades();
                }
            })
            .catch(({response})=>{
                loading.value = false;
                errManager(response)
            })
        };

        const onClosed = () => {
            atleta1.value = null;
            atleta2.value = null;
        }

        return {
            loading,
            titleDialog,
            isModalVisible,
            listModalidades,
            isModalSelection,
            listNominal,
            loadingSelection,
            getTest,
            atleta1,
            atleta2,
            //events
            openModal,
            getModalidades,
            onOpen,
            addPrueba,
            guardarSeleccion,
            deleteTest,
            guardarDoble,
            deleteDouble,
            onClosed
        }
        
    },
})
